import Vue from 'vue'
import Router from 'vue-router'
import routeName from '@/router/routeNames'
import Page404 from '@/pages/Page404'
import PG_Login from '@/pages/Login'
import PG_Home from '../containers/DefaultContainer'
import PG_Dashboard from '@/views/dashboard/Index'
import PG_ClientList from '@/views/clients/list/Index'
import PG_ClientNew from '@/views/clients/new/Index'
import PG_User from '@/views/user/Index'
import PG_UserList from '@/views/user/list/Index'
import PG_SetPassword from '@/pages/public/PasswordReset'
import PG_ResetPassword from '@/pages/public/ForgotPassword'
import PG_Transactions from '@/views/transactions/list/Index'
import PG_Nvi from '@/views/nvi/Index'
import store from '@/store/store'
import * as r_permission from '@/shared/route_permission'
import {USER_DATA} from "@/shared/constants";

Vue.use(Router)

const router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: function (to) {
        if (to.hash) {
            return {selector: to.hash, offset: {y: 100}}
        } else {
            return {y: 0}
        }
    },
    routes: [
      {path: '/login', name: routeName.RN_LOGIN, component: PG_Login},
      {path: '/set-password', name: routeName.RN_SET_PASSWORD, component: PG_SetPassword},
      {path: '/reset-password', name: routeName.RN_RESET_PASSWORD, component: PG_ResetPassword},
      {
        path: '/',
        redirect: '/dashboard',
        name: routeName.RN_HOME,
        component: PG_Home,
        meta: {
          t: "MAIN_PG",
        },

        children: [
          {
            path: 'dashboard',
            name: routeName.RN_DASHBOARD,
            component: PG_Dashboard,
            meta: {
              t:"DASHBOARD"
            },
          },
          {
            path: 'user-settings',
            name: routeName.RN_USER_SETTINGS,
            component: PG_User,
            meta: {
              permission_id: r_permission.R_USER_SETTINGS
            },
          },
          {
            path: 'transactions',
            name: routeName.RN_TRANSACTION_LIST,
            component: PG_Transactions,
            meta: {
              permission_id: r_permission.R_TRANSACTIONS
            },
          },
          {
            path: 'clients',
            name: routeName.RN_CLIENTS,
            component: PG_ClientList,
            meta:{
              permission_id: r_permission.R_CLIENTS,
              t:"CLIENTS"
            }
          },
          {
            path:'users',
            name:routeName.RN_USER_LIST,
            component:PG_UserList,
            meta:{
             permission_id: r_permission.R_USERS,
              t:"USERS"
            }
          },
          {
            path:'nvi',
            name:routeName.RN_NVI,
            component:PG_Nvi,
            meta:{
              permission_id: r_permission.R_NVI,
              t:"nvi"
            }
          },
          ]
      },
      // last route, replace with 404 page
      {path: '*', component: Page404},

]
})

router.beforeEach((to, from, next) => {

  if (typeof to.meta.permission_id === 'undefined') {
    next()
  } else {
    if (store.getters['user/getPermission'](to.meta.permission_id)) {
      next()
    } else {
      // redirect to login
      next(from.fullPath)
    }
  }
})

export default router
